import { Directive } from '@angular/core';
import { Controller } from '@commoncore/controller/Controller';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';

@Directive()
export class HomeScreenController extends Controller{
    public allFilesImplementation:any;
    public fileOperationsImplementation:any;
    public universalService:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null
    public globalService: any;
    public homeController:any;
    public listService: any;
    public localStorageSvc: LocalStorageSvc;
    loggerService: any;
    containerHeightCalc:any;
    
    public constructor(globalService) {
      super(globalService);
      this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
    }
    
    public static getInstance(globalService):HomeScreenController{
		if(this.singleInstance == null){
			this.singleInstance = new HomeScreenController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

    public setEnvObjects(globalService){
      this.globalService= globalService
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef(); 
      this.listService = globalService.getListServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
      this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    }

    

    async updateUIAfterPerformingAction(list,executedTask){
      var array = []
      if(executedTask == 'TRASH' || executedTask == "MOVE"){
        if(executedTask == "MOVE" && this.universalService.selectedFolder.objectName == 'Private Folder'){
            executedTask = "MOVETOPF"
        }
          this.fileOperationsImplementation.setHandler(this.globalService);
            var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
            array = result
      }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
          array = result
      }else{
          this.loggerService.log("task invalid",executedTask)
      }
      if(array && array.length == 0){
        return "empty"
      }else{
        return ""
      }
  }
}